<div
    class="mobile-dropdown-container w-full overflow-hidden transition-all duration-300 ease-in-out"
    *ngIf="menuData"
    [class.active]="isVisibleState$ | async">
    <div class="mobile-dropdown-content bg-gray-50 p-4 dark:bg-contrast-black" *ngIf="menuData">
        <div class="dropdown-main" [ngSwitch]="menuData.layout">
            <!-- Two column layout -->
            <div class="space-y-4" *ngSwitchCase="'two-column'">
                <div class="dropdown-section" *ngIf="menuData.header">
                    <h3 class="text-primary-header mb-3 text-base dark:text-contrast-yellow">
                        {{ menuData.header.title | translate | uppercase }}
                    </h3>
                    <div class="grid grid-cols-2 gap-6 sm:gap-6" *ngIf="menuData.header.items">
                        <div class="header-item" *ngFor="let item of menuData.header.items">
                            <a
                                class="menu-item-label text-primary"
                                *ngIf="!item.isExternal"
                                [routerLink]="item.path | localize">
                                {{ item.label | translate }}
                            </a>
                            <a
                                class="menu-item-label text-primary"
                                *ngIf="item.isExternal"
                                [href]="item.path | translate">
                                {{ item.label | translate }}
                            </a>
                            <p
                                class="text-primary-header mt-1 text-xs dark:text-contrast-yellow"
                                *ngIf="item.description">
                                {{ item.description | translate }}
                            </p>
                            <div
                                class="menu-item-notice mt-1 flex items-center text-primary dark:text-contrast-yellow"
                                *ngIf="item.notice">
                                <mat-icon class="mr-1 text-sm">info</mat-icon>
                                {{ item.notice | translate }}
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="custom-border-line mb-4 dark:!border-contrast-yellow" *ngIf="menuData.header" />

                <div class="dropdown-section" *ngFor="let section of menuData.sections">
                    <h3 class="text-primary-header mb-3 text-base dark:text-contrast-yellow">
                        {{ section.title | translate | uppercase }}
                    </h3>
                    <div class="grid grid-cols-2 gap-6 sm:gap-6">
                        <div class="dropdown-item" *ngFor="let item of section.items">
                            <a
                                class="menu-item-label text-primary"
                                *ngIf="!item.isExternal"
                                [routerLink]="item.path | localize">
                                {{ item.label | translate }}
                            </a>
                            <a
                                class="menu-item-label text-primary"
                                *ngIf="item.isExternal"
                                [href]="item.path | translate">
                                {{ item.label | translate }}
                            </a>
                            <p
                                class="text-primary-header mt-1 text-xs dark:text-contrast-yellow"
                                *ngIf="item.description">
                                {{ item.description | translate }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Stack layout -->
            <div class="space-y-4" *ngSwitchCase="'stack'">
                <div class="dropdown-section" *ngIf="menuData.header">
                    <h3 class="text-primary-header mb-3 text-base dark:text-contrast-yellow">
                        {{ menuData.header.title | translate | uppercase }}
                    </h3>
                    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-6" *ngIf="menuData.header.items">
                        <div class="header-item" *ngFor="let item of menuData.header.items">
                            <a
                                class="menu-item-label text-primary"
                                *ngIf="!item.isExternal"
                                [routerLink]="item.path | localize">
                                {{ item.label | translate }}
                            </a>
                            <a
                                class="menu-item-label text-primary"
                                *ngIf="item.isExternal"
                                [href]="item.path | translate">
                                {{ item.label | translate }}
                            </a>
                            <p
                                class="text-primary-header mt-1 text-xs dark:text-contrast-yellow"
                                *ngIf="item.description">
                                {{ item.description | translate }}
                            </p>
                            <div
                                class="menu-item-notice mt-1 flex items-center text-primary dark:text-contrast-yellow"
                                *ngIf="item.notice">
                                <mat-icon class="mr-1 text-sm">info</mat-icon>
                                {{ item.notice | translate }}
                            </div>
                        </div>
                    </div>
                </div>

                <hr class="custom-border-line mb-4 dark:!border-contrast-yellow" *ngIf="menuData.header" />

                <div class="dropdown-section" *ngFor="let section of menuData.sections">
                    <h3 class="text-primary-header mb-3 text-base dark:text-contrast-yellow">
                        {{ section.title | translate | uppercase }}
                    </h3>
                    <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-6">
                        <div class="dropdown-item" *ngFor="let item of section.items">
                            <a
                                class="menu-item-label text-primary"
                                *ngIf="!item.isExternal"
                                [routerLink]="item.path | localize">
                                {{ item.label | translate }}
                            </a>
                            <a
                                class="menu-item-label text-primary"
                                *ngIf="item.isExternal"
                                [href]="item.path | translate">
                                {{ item.label | translate }}
                            </a>
                            <p
                                class="text-primary-header mt-1 text-xs dark:text-contrast-yellow"
                                *ngIf="item.description">
                                {{ item.description | translate }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- List layout -->
            <div class="dropdown-section" *ngSwitchCase="'list'">
                <h3 class="text-primary-header mb-3 text-sm font-medium" *ngIf="menuData.title">
                    {{ menuData.title | translate | uppercase }}
                </h3>
                <div class="space-y-2">
                    <div class="dropdown-item" *ngFor="let item of menuData.items">
                        <a
                            class="menu-item-label list-layout block py-1 text-primary"
                            *ngIf="!item.isExternal"
                            [routerLink]="item.path | localize">
                            {{ item.label | translate }}
                        </a>
                        <a
                            class="menu-item-label list-layout block py-1 text-primary"
                            *ngIf="item.isExternal"
                            [href]="item.path | translate">
                            {{ item.label | translate }}
                        </a>
                    </div>
                </div>
            </div>

            <!-- Mixed layout -->
            <div class="space-y-6" *ngSwitchCase="'mixed'">
                <div class="dropdown-section" *ngFor="let section of menuData.sections">
                    <h3 class="text-primary-header mb-3 text-base dark:text-contrast-yellow">
                        {{ section.title | translate | uppercase }}
                    </h3>
                    <div class="space-y-2">
                        <div class="dropdown-item" *ngFor="let item of section.items">
                            <a
                                class="menu-item-label mixed-layout block py-1 text-primary"
                                *ngIf="!item.isExternal"
                                [routerLink]="item.path | localize">
                                {{ item.label | translate }}
                            </a>
                            <a
                                class="menu-item-label mixed-layout block py-1 text-primary"
                                *ngIf="item.isExternal"
                                [href]="item.path | translate">
                                {{ item.label | translate }}
                            </a>
                            <p
                                class="text-primary-header mixed-layout mt-1 text-xs dark:text-contrast-yellow"
                                *ngIf="item.description">
                                {{ item.description | translate }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
